import React from 'react';
import { Grid, IconType, ISelectOption, ISpruceFieldProps, RotatingIcon, Select, SpruceField } from 'ui-toolkit';
import { PreExistingContactDisplay } from './PreExistingContactDisplay';
import { FormikContextType } from 'formik';

interface IPreExistingContactSelectProps {
  isFetching: boolean;
  options: ISelectOption[];
  handleChange: (formik: FormikContextType<any>, option?: ISelectOption) => void;
  label: string;
}

export const PreExistingContactSelect: React.FC<IPreExistingContactSelectProps> = ({
  isFetching,
  options,
  handleChange,
  label,
}) => (
  <Grid templateColumns={isFetching ? '1fr min-content' : '1fr'}>
    <SpruceField name={'name'} inputType={'select'}>
      {({ field, formik }: ISpruceFieldProps) => (
        <>
          <Select
            {...field}
            label={label}
            options={options}
            isMulti={false}
            isClearable={true}
            onChange={(value: ISelectOption) => {
              handleChange(formik, value);
            }}
          />
          <PreExistingContactDisplay
            fullName={`${formik.values.firstName} ${formik.values.lastName}`}
            email={formik.values.email}
            companyName={formik.values.companyName}
          />
        </>
      )}
    </SpruceField>
    {isFetching && <RotatingIcon type={IconType.Loading} />}
  </Grid>
);
